var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"officials-page-toggle ",class:['segmented-buttons', {'segmented-buttons--large': _vm.largeButtons}]},_vm._l((_vm.toggleData),function(ref){
var routeName = ref.routeName;
var text = ref.text;
var isCurrent = ref.isCurrent;
return _c('router-link',{key:routeName,class:_vm.buttonClass(isCurrent),attrs:{"to":{ name: routeName },"aria-current":isCurrent ? 'page' : false}},[_vm._v("\n    "+_vm._s(text)+"\n  ")])}))}
var staticRenderFns = []

export { render, staticRenderFns }